import React from "react";
import {Box, Link, Typography} from "@mui/material";
import {lxStyled} from "@lxo-blocks/react";

const PREFIX = 'Impressum';
const classes = {
    link: `${PREFIX}-link`
}
const ImpressumContainer = lxStyled(Box)(({theme}) => ({
    [`.${classes.link}`]: {
        color: `${theme.palette.text.secondary}`
    }
}));
export default function Impressum() {
    return (
        <ImpressumContainer textAlign="center">
            <Typography variant="caption">
                <Link
                    sx={{mr:3}}
                    className={`${classes.link}`}
                    href="https://www.lexoffice.de/impressum/"
                    target="_blank"
                    underline="hover">Impressum</Link>
                <Link
                    sx={{mr:3}}
                    className={`${classes.link}`}
                    href="https://www.lexoffice.de/agb/"
                    target="_blank"
                    underline="hover">AGB</Link>
                <Link
                    sx={{mr:3}}
                    className={`${classes.link}`}
                    href="https://www.lexoffice.de/datenschutz/"
                    target="_blank"
                    underline="hover">Datenschutz</Link>
                <Link
                    className={`${classes.link}`}
                    href="https://www.lexoffice.de/status"
                    target="_blank"
                    underline="hover">Status</Link>
            </Typography>
        </ImpressumContainer>
    );
}
